// Button props
import { Link, LinkProps } from 'react-router-dom';
import classNames from 'classnames';

import ButtonClean, { IButtonCleanProps } from '~/components/ButtonClean';

import styles from './ButtonLink.module.scss';

export type TButtonLinkProps = IButtonCleanProps | LinkProps;

export const hasTo = (
  props: IButtonCleanProps | LinkProps,
): props is LinkProps => 'to' in props;

const ButtonLink = (props: TButtonLinkProps): JSX.Element => {
  const className = classNames(styles.buttonLink, props.className);
  if (hasTo(props)) {
    return (
      <Link
        {...props}
        className={classNames(styles.Link, className)}
      />
    );
  }
  return (
    <ButtonClean
      {...props}
      className={className}
    />
  );
};

export default ButtonLink;
